// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ee1ab81d","513":"eb82c6ce","787":"792a50db"}[chunkId] + ".chunk.js";
};